/**
 * Design system entry point.
 *
 * Load order matters: the WPDS token stylesheet defines `--wpds-*` defaults on `:root`, then
 * our fonts, then WP Cloud's token overrides, then the element-level base rules (both scoped to
 * `html.wpcloud-redesign`). Import this module
 * once, from `src/index.tsx`, before the app stylesheet.
 */
import '@wordpress/theme/design-tokens.css';
import './fonts.scss';
import './tokens.scss';
import './base.scss';
import './controls.scss';

import feature from 'lib/utils/feature';

export const REDESIGN_CLASS = 'wpcloud-redesign';

/**
 * Turn the redesign theme on for the whole document when the `wpcloud-redesign` flag is set.
 * Applied to `<html>` (not the React root) so portaled UI — popovers, modals, tooltips — inherits it.
 */
export function applyRedesignTheme( root: HTMLElement = document.documentElement ): boolean {
	const enabled = !! feature( 'wpcloud-redesign' );
	root.classList.toggle( REDESIGN_CLASS, enabled );
	return enabled;
}
